import { defineComponent } from "vue";
import UploadBox from "../../components/UploadBox";
import InvoiceLayout from "../../layouts/InvoiceLayout";

export default defineComponent({
    components: {
        UploadBox,
        InvoiceLayout,
    },

    template: `
        <InvoiceLayout>
            <div class="StepInvoice">
                <h2>Dodaj jedną z faktur od swojego aktualnego sprzedawcy energii, a my znajdziemy dla Ciebie najlepszy sposób na to, by cieszyć się Respectem!</h2>

                <UploadBox
                    class="contentbox contentbox--nomobile"
                    :options="options"

                    @next="$emit('next')"
                />
            </div>
        </InvoiceLayout>
    `,

    emits: [
        'next',
    ],

    props: {
        /** @var OfferJson */
        options: { type: Object, required: true },
    },
});
